/**
 * @generated SignedSource<<84f3b9fc3b795d88d2e17d5d58c63f62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsStockInfo_StoreProduct$data = {
  readonly stockInfo: {
    readonly otherLocations: ReadonlyArray<{
      readonly availableQuantity: number | null;
      readonly name: string | null;
    } | null> | null;
    readonly store: {
      readonly quantity: number | null;
    } | null;
  } | null;
  readonly " $fragmentType": "ProductDetailsStockInfo_StoreProduct";
};
export type ProductDetailsStockInfo_StoreProduct$key = {
  readonly " $data"?: ProductDetailsStockInfo_StoreProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsStockInfo_StoreProduct">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsStockInfo_StoreProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductStoreStock",
      "kind": "LinkedField",
      "name": "stockInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductStoreStoreStockSchema",
          "kind": "LinkedField",
          "name": "store",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantity",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductDistributionCenter",
          "kind": "LinkedField",
          "name": "otherLocations",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availableQuantity",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "2892a7e2187b5e1a60a98344e4d00c41";

export default node;
